import { useGetSubTopicById } from '../../api/useGetSubTopicById';
import { useUpdateSubTopic } from '../../api/useUpdateSubTopic';

type Props = {
  subTopicId: string;
};

export function useEventColorConfig(props: Props) {
  const { data: subTopic, isLoading } = useGetSubTopicById(props.subTopicId);
  const updateSubTopicMutation = useUpdateSubTopic();

  const selectedColor = subTopic?.event_color ?? null;

  function handleSelectColor(color: string | null) {
    if (color === selectedColor) {
      return;
    }

    updateSubTopicMutation.mutate({
      id: props.subTopicId,
      command: {
        event_color: color,
      },
    });
  }

  return {
    selectedColor,
    handleSelectColor,
    isLoading,
    isUpdating: updateSubTopicMutation.isPending,
  };
}
